import { render, staticRenderFns } from "./ContentBaseLayout.vue?vue&type=template&id=105d5546&scoped=true"
import script from "./ContentBaseLayout.vue?vue&type=script&lang=js"
export * from "./ContentBaseLayout.vue?vue&type=script&lang=js"
import style0 from "./ContentBaseLayout.vue?vue&type=style&index=0&id=105d5546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "105d5546",
  null
  
)

export default component.exports